export const BotApiTokenScopesArr = ["userlist:read", "userlist:write", "userlistorg:read", "supervisor:read", "keyval:read", "keyval:write", "bot:read", "bot:write", "skills:read", "skills:write", "stages:read", "stages:write", "fusion:read", "fusion:write", "embedding:read", "embedding:write", "changelog:read", "stats:read"] as const

export type BotApiTokenScopes = typeof BotApiTokenScopesArr[number]
export type BotApiToken<ID = string, D = string> = {
  _id: ID,
  name: string,
  token: string,
  botId: ID,
  scopes: BotApiTokenScopes[]
  lastUsed: D
}

export const ProjectApiTokenScopesArr = ["projectdoc:read", "projectdoc:write", "projectdoc:chunk", "bots:read", "bots:write", "projectkeyval:read", "projectkeyval:write", "skills:read", "skills:write", "stages:read", "stages:write", "fusion:read", "fusion:write", "embedding:read", "embedding:write", "changelog:read", "stats:read"] as const

export type ProjectApiTokenScopes = typeof ProjectApiTokenScopesArr[number]
export type ProjectApiToken<ID = string, D = string> = {
  _id: ID,
  name: string,
  token: string,
  projectId: ID,
  scopes: ProjectApiTokenScopes[]
  lastUsed: D
}
